<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 9
      h1 Decapado

    img(data-aos="fade-up")(src="@/assets/curso/temas/tema9/1.png", alt="Imagen decorativa")

    .row.justify-content-center.mb-4
      .col-xl-10(data-aos="fade-down")
        div.banner-text.bg-color-primario-p10
          p.mb-0 En los procesos de fabricación y acabado de piezas de joyería, resulta esencial garantizar que los metales mantengan una apariencia limpia, uniforme y libre de impurezas superficiales que puedan afectar su calidad final. Durante las distintas etapas de conformado, soldadura o calentamiento, los metales desarrollan residuos, manchas u óxidos que dificultan su manipulación y alteran su estética. Para enfrentar estos retos, los joyeros recurren a un procedimiento químico específico que permite restaurar la superficie del metal y prepararlo adecuadamente para los siguientes pasos del trabajo artesanal o industrial.

    Separador
    .row.justify-content-center.z-2
      .col-xl-10
        #t_9_1.titulo-segundo.color-acento-contenido
          .h2(data-aos="fade-right") 9.1 Concepto
    
    .row.justify-content-center.align-items-center.z-2
      .col-6.col-md-4.col-lg-2
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema9/2.png" alt="Imagen decorativa" data-aos="fade-down")
      .col-lg-8
        p El decapado es un proceso químico utilizado para eliminar los óxidos, manchas y residuos superficiales que se forman en los metales preciosos (oro, plata, cobre, bronce) después de ser sometidos a calentamiento, soldadura o recocido. El metal se sumerge en una solución ácida llamada <em>pickle</em>, cuya función es limpiar la superficie sin alterar la estructura interna del material. El resultado es un metal más limpio, brillante y apto para posteriores acabados como pulido, engaste o baños galvánicos.

    Separador
    .row.justify-content-center.z-2
      .col-xl-10
        #t_9_2.titulo-segundo.color-acento-contenido
          .h2(data-aos="fade-right") 9.2 Clases
    .row.justify-content-center.align-items-center.mb-5
      .col-10.col-md-6.col-lg-3
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema9/3.png" alt="Imagen decorativa" data-aos="fade-down")
      .col-lg-7
        p Las diversas clases de decapado utilizadas en joyería surgen de la necesidad de adaptar el proceso de limpieza a las características del metal, al nivel de oxidación presente y al tipo de tratamiento térmico o de soldadura aplicado previamente. Estas variantes permiten seleccionar el método más adecuado según la intensidad de los residuos, la delicadeza de la pieza y los resultados esperados, garantizando así un procedimiento seguro, eficiente y acorde con las exigencias técnicas del trabajo joyero.
        p.mb-0 Aunque todos cumplen la misma función, pueden clasificarse según su intensidad y finalidad:

    .row.justify-content-center.z-2.mb-4.mb-lg-5
      .col-sm-6.col-xl-4.mb-4.mb-xl-0
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema9/4.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center Decapado suave
            ul.checklist
              li.mb-3 Diseñado para piezas delicadas o metales sensibles.
              li.mb-3 Utiliza ácidos poco concentrados.
              li Limpia óxidos ligeros y manchas superficiales.
              

      .col-sm-6.col-xl-4.mb-4.mb-xl-0
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema9/5.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center Decapado fuerte
            ul.checklist
              li.mb-3 Empleado cuando hay alta presencia de óxidos o residuos endurecidos.
              li.mb-3 Utiliza soluciones más potentes y requiere mayor control.
              li No es recomendado para piezas frágiles o con gemas sensibles.

      .col-sm-6.col-xl-4.mb-4.mb-xl-0
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema9/6.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center Decapado electrolítico
            ul.checklist
              li.mb-3 Combina solución ácida con corriente eléctrica.
              li.mb-3 Acelera el proceso de limpieza.
              li Puede ser más eficiente en metalurgia de precisión.


    Separador
    .row.justify-content-center.z-2
      .col-xl-10
        #t_9_3.titulo-segundo.color-acento-contenido
          .h2(data-aos="fade-right") 9.3 Técnicas
    
    .row.justify-content-center.align-items-center.z-2.mb-5
      .col-6.col-md-4.col-lg-2
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema9/7.png" alt="Imagen decorativa" data-aos="fade-down")
      .col-lg-8
        p Las técnicas de decapado en joyería se diferencian principalmente por la forma en que se aplica el agente químico y por la intensidad del proceso requerido para eliminar los óxidos y residuos metálicos. Cada método busca optimizar la limpieza según la naturaleza de la pieza y el tipo de trabajo realizado, garantizando una superficie uniforme y lista para los acabados posteriores.

    .titulo-sexto.color-acento-contenido.mb-4.z-2
      h5 Tabla 10.
      span Técnicas de decapado
    .tabla-a.color-secundario.tabla-a--left.z-2
      table
        caption <strong>Fuente:</strong> SENA, 2025.
        thead(style="background-color: #FAF8F4;")
          tr
            th Técnica de decapado
            th Descripción
            th Aplicación típica
            th Ventajas
            th Limitaciones
        tbody
          tr
            td <strong>Decapado químico por inmersión.</strong>
            td La pieza se sumerge en una solución ácida caliente para remover óxidos superficiales.
            td Limpieza de piezas después de soldaduras o recocidos.
            td Eficiente, uniforme y rápido.
            td Requiere control de temperatura y manejo cuidadoso de ácidos.
          tr
            td <strong>Decapado químico por aplicación localizada.</strong>
            td El ácido se aplica solo en áreas específicas usando pincel o gotero.
            td Piezas delicadas o con zonas sensibles a la corrosión.
            td Reduce riesgo de afectar áreas no deseadas.
            td Menos uniforme y más lento.
          tr
            td <strong>Decapado mecánico suave.</strong>
            td Uso de abrasivos finos (fibra, lijas suaves) para retirar óxidos manualmente.
            td Limpieza previa o posterior a procesos menores en metales duros.
            td Control manual, no requiere químicos.
            td No elimina óxidos profundos; puede rayar.
          tr
            td <strong>Decapado por ultrasonido (con solución decapante suave).</strong>
            td La vibración ultrasónica potencia la acción de una solución limpiadora.
            td Limpieza de piezas pequeñas y detalles complejos.
            td Muy eficiente en cavidades y filigranas.
            td Requiere equipo especializado.
          tr
            td <strong>Decapado térmico + químico.</strong>
            td Se calienta la pieza para oxidar completamente y luego se limpia en ácido.
            td Preparación para acabado final o restauraciones.
            td Elimina completamente la capa superficial.
            td Debe hacerse con precisión para evitar fragilización.

    Separador
    .row.justify-content-center.z-2
      .col-xl-10
        #t_9_4.titulo-segundo.color-acento-contenido
          .h2(data-aos="fade-right") 9.4 Tipos de ácidos para decapados
    .row.justify-content-center.align-items-center.factores-slider.z-2.mb-5

      .col-10.col-sm-6.col-lg-3
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema9/8.png" alt="Imagen decorativa" data-aos="fade-down")
      .col-lg-9.col-xl-7
        p Cada ácido posee propiedades químicas específicas que actúan de manera distinta sobre los óxidos metálicos y las impurezas generadas durante la fundición, el recocido o la soldadura. Comprender sus características, concentraciones recomendadas y niveles de reactividad permite seleccionar la opción más segura y efectiva, optimizando la preparación de las piezas para etapas posteriores de acabado.
        p.mb-0 Entre los más usados tenemos:


    .row.justify-content-center.align-items-center.z-2
      .col-xl-10
        .titulo-sexto.color-acento-contenido.mb-4.z-2
          h5 Tabla 11.
          span Tipos de ácidos utilizados en el decapado
        .tabla-a.color-secundario.tabla-a--left.z-2
          table
            caption <strong>Fuente:</strong> SENA, 2025.
            thead(style="background-color: #FAF8F4;")
              tr
                th Ácido / Solución
                th Uso principal
                th Consideraciones
            tbody
              tr
                td <strong>Ácido sulfúrico diluido (10-20 %).</strong>
                td Decapado fuerte y general.
                td Requiere calor; muy efectivo para plata y cobre.
              tr
                td <strong>Ácido nítrico diluido.</strong>
                td Eliminación rápida de óxidos.
                td Puede dañar aleaciones sensibles; muy corrosivo.
              tr
                td <strong>Bisulfato sódico comercial (Sparex).</strong>
                td Decapado suave y seguro.
                td Amplio uso en joyería; menos peligroso.
              tr
                td <strong>Ácido clorhídrico diluido.</strong>
                td Remover óxidos de cobre y latón.
                td No recomendable para plata por riesgo de pitting.
              tr
                td <strong>Soluciones comerciales <em>"pickle"</em></strong>
                td Limpieza controlada para metales preciosos.
                td Fáciles de usar, menos tóxicas.


    Separador
    .row.justify-content-center.z-2
      .col-xl-10
        #t_9_5.titulo-segundo.color-acento-contenido
          .h2(data-aos="fade-right") 9.5 Cuidados en el uso de decapantes

    .row.justify-content-center.z-2
      .col-xl-10
        p La correcta aplicación de los cuidados garantiza no solo la integridad del joyero, sino también la calidad del metal, la preservación de las herramientas y la prevención de accidentes en el taller. A continuación, se presentan los cuidados esenciales clasificados en grupos para su estudio y aplicación.

    .row.justify-content-center.align-items-center.z-2.factores-slider
      .col-10.col-md-6.col-lg-3
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema9/10.png" alt="Imagen decorativa" data-aos="fade-down")
      .col-lg-9.col-xl-7
        .bg-slider.p-4.rounded-4
          SlyderF(columnas="col-12")
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Seguridad personal
              p Uso obligatorio de guantes resistentes a químicos, gafas protectoras, mascarilla para vapores y ropa de trabajo que cubra la piel.
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Manipulación de ácidos
              p Agregar el ácido al agua (nunca al revés), usar recipientes no reactivos, evitar aluminio, controlar la temperatura y mantener herramientas sin grasa.
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Área de trabajo
              p Garantizar buena ventilación, disponer de agua cercana, usar superficies resistentes a la corrosión y tener bicarbonato como neutralizante.
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Proceso de decapado
              p Usar pinzas adecuadas, no mezclar metales, controlar tiempos de inmersión, enjuagar con agua y neutralizar con bicarbonato al finalizar.
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Mantenimiento del decapante
              p Cambiar la solución cuando pierda eficacia, no mezclar ácidos nuevos con viejos, filtrar impurezas y almacenar correctamente con rótulos.
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Disposición ambiental
              p Neutralizar el ácido antes de desecharlo y llevarlo a gestores autorizados; nunca verterlo activo al desagüe.
            .tarjeta.tarjeta--blanca.p-4
              h4.mb-4 Detección de peligros
              p Estar atento a olores fuertes, cambios de color, ebullición repentina o manchas en el metal; detener el proceso de inmediato ante cualquier señal.

</template>

<script>
export default {
  name: 'Tema9',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
